export default __webpack_public_path__ + "static/Muli-ExtraBold-844c2453373f78dd8230ca34e5b58aeb.ttf";